/* eslint-disable no-console */
import { getUrlParameter } from '../../utils/utilities';
import { redirectToRegion, cookieStorage } from '../region-selector';
import { toggleModal } from '../modal';
import RegionIPDetection from './region-ip-detection';
import { cleanLangURL, getGroupedRegion } from '../../utils/regionUtil';
const expires = new Date();
const days = 30;
expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
const showPopup = (ipDetectedRegionCountry) => {
    const popupContent = document.querySelector('#region-redirector .modal__body');
    const popupTitle = document.createElement('div');
    popupTitle.innerHTML = window.regionDetectionTitle.replace('{COUNTRY}', ipDetectedRegionCountry);
    const popupGrid = document.querySelector('#region-redirector .modal__body .region-selector__grid');
    popupContent.insertBefore(popupTitle, popupGrid);
    document.body.classList.add('region-redirector-opened');
    toggleModal('region-redirector');
};
const getRedirectLink = (region, language, currency, isDefault, redirectPath) => {
    // This assumes all our permanent domains are in the following format: rationale-<countryCode>-<environment>
    const environment = window.permanentDomain.split('.')[0].split('-')[2];
    // Filter out other regions and remove language from pathname before redirecting
    const path = redirectPath || cleanLangURL();
    let targetRegion = region.toLowerCase();
    if (targetRegion === 'gb' || targetRegion === 'gbr') {
        targetRegion = 'uk';
    }
    if (!Shopify.designMode) {
        return `https://rationale-${targetRegion}-${environment}.myshopify.com${path || ''}?m=1`;
        if (language && currency) {
            return `https://rationale-${targetRegion}-${environment}.myshopify.com/${isDefault ? '' : language}${path || ''}?currency=${currency}&m=1&r=${region}`;
        }
        else {
        }
    }
};
const init = () => {
    const debug = sessionStorage.getItem('debug:region-redirection');
    if (debug) {
        console.info('Debugging Region Automatic Redirection (RAR)');
        console.info('RAR:', 'Current Region', window.currentRegion, 'Current Region Code', window.currentRegionCode, 'Regions List Data', window.regionsListData);
    }
    if (window.currentRegion && window.currentRegionCode && window.regionsListData) {
        if (debug) {
            console.info('RAR: Required settings loaded correctly');
        }
        const botPattern = '(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';
        const re = new RegExp(botPattern, 'i');
        const isManuallySelectedFromUrl = getUrlParameter('m');
        if (isManuallySelectedFromUrl) {
            cookieStorage.setItem('rrManuallySelected', '1', {
                path: '/',
                expires,
            });
            window.history.replaceState(window.history.state, '', window.location.href.split('?')[0]);
        }
        const isManuallySelected = isManuallySelectedFromUrl || cookieStorage.getItem('rrManuallySelected');
        // If the url contains rg as a parameter, we enfore a redirection even if the customer has manually selected to visit the region
        let isForcedReCheck = getUrlParameter('rg');
        const lastSelectionRegionCode = cookieStorage.getItem('rrLastSelection');
        // If the last region selected was a different region then we don't enforce a re-check
        if (lastSelectionRegionCode !== null && lastSelectionRegionCode !== window.currentRegionCode) {
            isForcedReCheck = false;
        }
        window.addEventListener('region-country-code-detected', (data) => {
            const { ipDetectedRegionCode, ipDetectedRegionCountry } = data.detail;
            const regionsIncludeLocationDetected = window.regionsListData.find((region) => {
                const regionCode = getGroupedRegion(ipDetectedRegionCode);
                return region.region_code === regionCode && !region.is_in_current_store;
            });
            // To debug open the console in your browser and type
            // sessionStorage.setItem('debug:region-redirection', '1');
            // then refresh the page
            if (debug) {
                console.info('Region detected', ipDetectedRegionCode, 'Current Region Code', window.currentRegionCode, 'isDesignMode', window.Shopify.designMode);
                console.info('Regions that Include the Location detected', regionsIncludeLocationDetected, 'Is Manually selected region', isManuallySelected, 'Forced to re-check', isForcedReCheck);
            }
            let redirectedAlready = cookieStorage.getItem('rrRedirected');
            if (ipDetectedRegionCode !== window.currentRegionCode && regionsIncludeLocationDetected && (!isManuallySelected || isForcedReCheck) && !redirectedAlready) {
                if (window.theme.automaticalRedirectionEnabled) {
                    if (window.Shopify.designMode !== true) {
                        if (lastSelectionRegionCode !== null && lastSelectionRegionCode !== '') {
                            //redirectToRegion(lastSelectionRegionCode);
                        }
                        else {
                            cookieStorage.setItem('rrRedirected', '1', {
                                path: '/',
                                expires,
                            });
                            redirectToRegion(regionsIncludeLocationDetected.region_code);
                        }
                    }
                    else if (debug) {
                        console.info('RAR: Autoredirection executed, but not redirected as you are in design mode');
                    }
                }
                else if (window.theme.showPopupRedirectionEnabled) {
                    let shownAlready = localStorage.getItem('regionAlertShown');
                    if (!shownAlready) {
                        const regionAlert = document.querySelector('.region-alert');
                        document.body.classList.add('body-region-alert--shown');
                        if (regionAlert) {
                            regionAlert.classList.add('region-alert--shown');
                        }
                        const userLocation = document.querySelector('[data-location]');
                        const svg = document.querySelector(`.region-alert__target .locale-icon--${regionsIncludeLocationDetected.currency.toLowerCase()}`);
                        const targetRegion = document.querySelector(`.region-alert__target-text`);
                        const changeButton = document.querySelector(`.region-alert__change`);
                        if (userLocation) {
                            userLocation.innerHTML = ipDetectedRegionCountry;
                            document.querySelectorAll('.region-alert__target .locale-icon--active').forEach((activeIcon) => {
                                activeIcon.classList.remove('locale-icon--active');
                            });
                            svg.classList.add('locale-icon--active');
                            targetRegion.innerHTML = regionsIncludeLocationDetected.title;
                            changeButton.setAttribute('href', getRedirectLink(regionsIncludeLocationDetected.region_code, regionsIncludeLocationDetected.language, regionsIncludeLocationDetected.currency));
                        }
                    }
                    /*
                    initModal('region-redirector');
                    if (lastSelectionRegionCode !== null && lastSelectionRegionCode !== '') {
                      redirectToRegion(lastSelectionRegionCode);
                    } else {
                      showPopup(ipDetectedRegionCountry);
                    }*/
                }
            }
            else {
                if (debug) {
                    console.info('RAR: The current region is the detected region, no autoredirection or popup to show');
                }
                window.dispatchEvent(new CustomEvent('ready-to-display-newsletter'));
            }
        });
        // Only execute if not a bot
        if (!re.test(navigator.userAgent)) {
            RegionIPDetection();
        }
    }
    else if (debug) {
        console.error('RAR: Missing Region Selector settings');
        if (!window.currentRegionCode) {
            console.error('RAR: You might need to set the region_code in the Region Selector Section settings. Go to the Theme and edit the section');
        }
    }
};
export default init;
